import { ResolveFn } from '@angular/router';
import {Organization} from "./organization.model";
import {OrganizationService} from "./organization.service";
import {inject} from "@angular/core";

export const organizationResolver: ResolveFn<Organization[]> = (route, state) => {
  const organizationService: OrganizationService = inject(OrganizationService)
  return organizationService.fetchAll()
};
